import { call, CallEffect, PutEffect } from "redux-saga/effects";
import { orderBy } from "lodash";

import { AxiosResponse } from "axios";
import { Action } from "redux-saga";
import { automaticApi } from "@/settings/api";

export interface Fetch {
  type: string;
  brandId: string;
  callback: (success: boolean, errorMessage?: string | unknown) => void;
}

export interface RequestModelsAction {
  type: string;
  payload: Fetch;
}

const uri = "/dominios/v1/veiculo/modelos";

export default function* requestModels({
  payload,
}: RequestModelsAction): Generator<
  CallEffect<unknown> | PutEffect<Action>,
  void,
  AxiosResponse
> {
  try {
    const body = {
      tipoVeiculo: payload.type ?? 1,
      identificadorMarcaVeiculo: payload.brandId,
    };

    const res: AxiosResponse = yield call(automaticApi.post, uri, body);

    if (res?.data?.totalRegistros > 0) {
      const models = orderBy(res?.data?.listaModeloVeiculo, [
        "descricao",
        "ASC",
      ]);
      const formattedModels = models.map((item) => ({
        text: item.descricao,
        value: item.identificadorModeloVeiculo,
        ...item,
      }));
      yield call(payload.callback, true, formattedModels);
    } else {
      yield call(payload.callback, false);
    }
  } catch (error) {
    yield call(payload.callback, false);
  }
}
